import { ChangeDetectionStrategy, Component, Input, signal, WritableSignal } from '@angular/core';

import { CollectionFinderItemDTO } from 'src/app/core/interfaces/collection.interface';
import { AddRemoveState } from '../../../../../enums/add-remove-state.enum';
import { ToastMessageService } from '../../../../../services/toast-message.service';
import { CollectionApiService } from '../../../../../services/collection-service/collection-api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'add-remove-button-collection',
  imports: [],
  templateUrl: './add-remove-button-collection.component.html',
  styleUrls: ['./add-remove-button-collection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddRemoveButtonCollectionComponent {
  @Input({ required: true }) set collection(_collection: CollectionFinderItemDTO) {
    this.collectionData = _collection;
    this.addRemoveState.set(_collection.isAdded ? AddRemoveState.REMOVE : AddRemoveState.ADD);
  }

  protected addRemoveState: WritableSignal<AddRemoveState> = signal(AddRemoveState.ADD);
  protected readonly AddRemoveState = AddRemoveState;
  private collectionData: CollectionFinderItemDTO = {} as CollectionFinderItemDTO;

  constructor(
    private readonly toastMessageService: ToastMessageService,
    private readonly collectionApiService: CollectionApiService,
    private readonly translate: TranslateService,
  ) {}

  protected toggleAddRemoveState() {
    const currentlyInAddState = this.addRemoveState() === AddRemoveState.ADD;
    const toggleAction = currentlyInAddState
      ? this.collectionApiService.addCollection(this.collectionData.id)
      : this.collectionApiService.removeCollection(this.collectionData.id);
    toggleAction.subscribe(() => {
      this.toastMessageService.openToastDialog({
        primaryMessage: this.collectionData.title,
        secondMessage: currentlyInAddState
          ? this.translate.instant('common.toast.added-successfully')
          : this.translate.instant('common.toast.removed-successfully'),
      });
      this.addRemoveState.set(currentlyInAddState ? AddRemoveState.REMOVE : AddRemoveState.ADD);
    });
  }
}
